import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from '../LoginButton/LoginButton';
import styles from './Profile.module.scss';
import { Dropdown, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Profile = () => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const { t } = useTranslation();

  if (isLoading) {
    return <Spinner />;
  }

  if (isAuthenticated && user) {
    const imageElement = <img className={styles.profileImage} src={user.picture} alt={user.name} />;

    return (
      // align="end"
      <Dropdown align={'end'}>
        <Dropdown.Toggle variant='secondary' className={styles.profileDropdown}>
          {imageElement}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.ItemText>{user.name}</Dropdown.ItemText>
          <Dropdown.ItemText>{user.email}</Dropdown.ItemText>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
            {t('LOG_OUT')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  } else {
    return <LoginButton />;
  }
};

export default Profile;
